// src/components/common/GlobalAdArea.js
import { useEffect, useState } from 'react';
import { StyledDevAdContainer } from '../../styles/globalAdAreaStyles';
import { useAd } from '../../contexts/AdContext';

import { AdArea } from '../../styles/displayPageStyles';

/**
 * アプリケーション全体で共有される広告エリアコンポーネント
 */
const GlobalAdArea = () => {
  const { isAdVisible } = useAd();
  const getIsMobile = () => {
    // CSSのメディアクエリ定義と一致させる
    // 1. Mobile (Small): max-width: 599px (medium - 1)
    const isSmall = window.innerWidth < 600;
    // 2. Tablet Portrait: min-width: 600px AND max-width: 1135px (large - 1) AND portrait
    const isTabletPortrait = window.innerWidth >= 600 && window.innerWidth < 1136 && window.matchMedia('(orientation: portrait)').matches;
    // 3. Mobile Landscape: max-height: 500px AND landscape
    const isMobileLandscape = window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches;
    // 4. Safety: Force mobile if width is less than 728px (PC ad width)
    const isNarrow = window.innerWidth < 728;

    return isSmall || isTabletPortrait || isMobileLandscape || isNarrow;
  };

  const [isMobile, setIsMobile] = useState(getIsMobile);

  // 画面幅を監視してisMobileを更新
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // 広告をロード
  useEffect(() => {
    if (isAdVisible) {
      try {
        if (window.adsbygoogle && window.adsbygoogle.push) {
          window.adsbygoogle.push({});
        }
      } catch (e) {
        console.error("AdSense push error:", e);
      }
    }
  }, [isAdVisible, isMobile]); // isMobileが変更されたときも再評価

  if (!isAdVisible) {
    return null;
  }

  const adClient = "ca-pub-6411357988225958";
  const mobileAdSlot = "7942262050";
  const pcAdSlot = "1698333625";

  return (
    <AdArea>
      {isMobile ? (
        <ins
          className="adsbygoogle"
          style={{ display: 'inline-block', width: '300px', height: '50px' }}
          data-ad-client={adClient}
          data-ad-slot={mobileAdSlot}
        ></ins>
      ) : (
        <ins
          className="adsbygoogle"
          style={{ display: 'inline-block', width: '728px', height: '90px' }}
          data-ad-client={adClient}
          data-ad-slot={pcAdSlot}
        ></ins>
      )}

      {process.env.NODE_ENV === 'development' && (
        <StyledDevAdContainer>
          広告プレースホルダー (ローカル開発用)
        </StyledDevAdContainer>
      )}
    </AdArea>
  );
};

export default GlobalAdArea;